import { Base } from '@studiometa/js-toolkit';

/**
 * ProductRecommendations
 */
export default class ProductLastViewed extends Base {
  storageProductsCard = 'recently_viewed_products_cards';
  storageProductsID = 'recently_viewed_products_id';

  /**
   * Component Configuration
   */
  static config = {
    name: 'ProductLastViewed',
    refs: ['template', 'container'],
  };

  /**
   *
   */
  mounted() {
    this.renderRecentlyViewedProducts();

    const currentStorageID = localStorage.getItem(this.storageProductsID)
      ? localStorage.getItem(this.storageProductsID)
      : '';
    const product = this.$refs.template.innerHTML;

    const { id } = this.$refs.template.dataset;

    if (currentStorageID !== null && currentStorageID.includes(id) === false) {
      localStorage.setItem(this.storageProductsID, `${currentStorageID} ${id}`);
      const currentProducts = JSON.parse(localStorage.getItem(this.storageProductsCard)) || [];
      currentProducts.unshift(product);

      if (currentProducts.length > 4) {
        currentProducts.pop();
      }

      localStorage.setItem(this.storageProductsCard, JSON.stringify(currentProducts));
    }
  }

  /**
   * Render products card in container
   * @returns {void}
   */
  renderRecentlyViewedProducts() {
    if (!this.$refs.container) return;

    const products = JSON.parse(localStorage.getItem(this.storageProductsCard)) || [];

    if (products.length === 0) {
      this.$el.classList.add('hidden');
      return;
    }

    this.$refs.container.innerHTML = products.join('');
  }
}
